import { useContext, useMemo } from 'react';

import { context } from '../provider/context';
import { useFormListStore } from '../provider/useFormStore';
import { FormyProvider } from '../types/form';

const useFormyContext = () => {
  const store = useFormListStore();
  const ctx = useContext(context);

  /**
   * Applies the global store if the context is not set
   */
  const _store = useMemo(() => ctx?.store ?? store, [store, ctx?.store]);

  return {
    ...ctx,
    store: _store,
  } as FormyProvider;
};

export { useFormyContext };
